import { createEpic, createDownloadEpic } from "../helpers";
import {
	getCommunityLeadersAsyncAction,
	getCommunityLeadersStatsAsyncAction,
	updateCommunityLeaderStatusAsyncAction,
	getCommunityLeaderAsyncAction,
	exportCommunityLeaderDataAsyncAction,
	getCommunityLeadersRegionsAsyncAction,
	exportCommunityLeaderRegionAsyncAction,
	exportCommunityLeaderMembersAndEventsAsyncAction
} from "./communityLeaderActions";

export const getCommunityLeadersEpic = createEpic(
	getCommunityLeadersAsyncAction,
	"communityLeader",
	"getList",
	true
);

export const getCommunityLeadersStatsEpic = createEpic(
	getCommunityLeadersStatsAsyncAction,
	"communityLeader",
	"getStats",
	true
);

export const getCommunityLeadersRegionEpic = createEpic(
	getCommunityLeadersRegionsAsyncAction,
	"communityLeader",
	"getRegionsStats",
	true
);

export const getCommunityLeaderEpic = createEpic(
	getCommunityLeaderAsyncAction,
	"communityLeader",
	"getDetail",
	true
);

export const updateCommunityLeaderStatusEpic = createEpic(
	updateCommunityLeaderStatusAsyncAction,
	"communityLeader",
	"updateStatus",
	true
);

export const exportPlayersEpic = createDownloadEpic(
	exportCommunityLeaderDataAsyncAction,
	"communityLeader",
	"exportCommunityLeaders",
	true,
	"community-leaders"
);

export const exportClRegionEpic = createDownloadEpic(
	exportCommunityLeaderRegionAsyncAction,
	"communityLeader",
	"exportCommunityLeadersArea",
	true,
	"community-leaders-regions"
);

export const exportMembersAndEvents = createDownloadEpic(
	exportCommunityLeaderMembersAndEventsAsyncAction,
	"communityLeader",
	"exportCommunityLeadersMembersAndEvents",
	true,
	"community-leaders-members-events"
);
